import classes from './ScrollToTop.module.css'
import { useWindowScroll } from 'react-use';
import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";
import {IoIosArrowUp} from 'react-icons/io';
import {BsMouse} from 'react-icons/bs';

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }

const ScrollToTop = () => {

    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const { y: pageYOffset } = useWindowScroll();
    const [visibleScrollToTop, setVisibilityScrollToTop] = useState(false);
    const [visibleScrollDown, setVisibilityScrollDown] = useState(true);

    useEffect(() => {
        function handleResize() {
          setWindowDimensions(getWindowDimensions());
        }
    
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, []);

    useEffect(() => {
        if(pageYOffset < windowDimensions.height*1){
            setVisibilityScrollDown(true);
            setVisibilityScrollToTop(false);
        }        
        else if(pageYOffset/(document.documentElement.scrollHeight-windowDimensions.height)> 0.3){
            setVisibilityScrollDown(false);
            setVisibilityScrollToTop(true);
        }
        else{
            setVisibilityScrollDown(false);
            setVisibilityScrollToTop(false);
        }
    }, [pageYOffset, windowDimensions.height])

    if(visibleScrollToTop){
        return(
            <Link className= {classes.ScrollToTop} to="uvod" spy={true} smooth={true} offset={-60} duration={500}>
                <IoIosArrowUp size='2.5rem' color='black' 
                    style={{
                        height:'auto',
                        width: '1.875rem',
                        color: '#EAE0D9',
                        transition: '0.2s'                        
                    }}
                />
            </Link>
        );
    } else if(visibleScrollDown){
        return(
            <Link className={classes.sipkaDole} to="Omne" spy={true} smooth={true} offset={-55} duration={500}>
                <BsMouse className={classes.sipkaDoleImg} size='2.5rem' color='black' 
                    style={{
                        height:'auto',
                        width: '2.5rem',
                        color: '#CAB59A',
                        transition: '0.5s',
                        marginBottom: "1rem"                      
                    }}
                    />
            </Link>            
        );
    } else {
        return false;      
    }
}
 
export default ScrollToTop;